import { Component, OnInit, ViewChild, ElementRef, TemplateRef, AfterViewInit } from '@angular/core';
import { ApiService } from 'src/app/api.service';
import { FunctionsService } from 'src/app/services/functions.service';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { aggressor } from 'src/app/models/aggressorModel';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

declare var Geofence;
var mapProperties;
var geofence;
var mapAlert:google.maps.Map;


@Component({
  selector: 'app-view-alert-history',
  templateUrl: './view-alert-history.component.html',
  styleUrls: ['./view-alert-history.component.css']
})
export class ViewAlertHistoryComponent implements OnInit{
  @ViewChild('aggressorDetailsModal') aggressorDetailsModal!: TemplateRef<any>;
  
  @ViewChild('videoPlayer', {static:true}) videoplayer: ElementRef;
  @ViewChild('mapAlert', { static: true })
  
  mapElementAlert: any;
  selectedAlert: any;
  profile: any = {};
  chatMessages: Array<any> = [];
  finalLatitude: any;
  finalLongitude: any;
  agentFinalLatitude: any;
  agentFinalLongitude: any;
  documents: any;
  videos: any;
  audioLinks: any;
  videoLinks: any;
  latLngList = [];
  agentLatLngList = [];
  positionAmount: number = 19;
  compositionList:any;
  alertId = 0;
  fieldOption: any;
  c_fields: any;
  alertTotalTime: any;
  attendTotal: any;
  closeTotal: any;
  days: any;
  geoAssignment: any;

  aggressors: aggressor[] = [];
  selectedAggressor: aggressor = null;

  constructor(
    public functionsService: FunctionsService,
    private apiService: ApiService,
    private angularFireStore: AngularFirestore,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private spinner: NgxSpinnerService) { 
      this.route.params.subscribe(params => {
        if(this.alertId != params['alertId']){
          this.alertId = params['alertId'];
          this.ngOnInit();
      }
          this.alertId = params['alertId'];
      });
    }

  ngOnInit() {
    this.getUserFieldOption();
    this.fetchAlert(this.alertId);
    this.loadAggressors();
    console.log('selectedAlert con created by', this.selectedAlert.createdBy);
  }


  fetchAlert(id){
    this.spinner.show();
    this.apiService.getAlertHistory(id).subscribe(
        data => {
            this.selectedAlert = data;
            this.viewAlert();
            this.geoAssignment = JSON.parse(localStorage.getItem('geoAssignment'));
            this.spinner.hide();
            console.log(this.selectedAlert);
            this.loadAggressors();
        },
        error => {
            this.spinner.hide();
            this.functionsService.errorHandler(error["status"]);
        }
    );
  }

  alertTimer(){
      var timeDifference = this.selectedAlert.timerStatus == 0 ? new Date(this.selectedAlert.closedDate).getTime() - new Date(this.selectedAlert.createdDate).getTime() : new Date(this.selectedAlert.canceledDate).getTime() - new Date(this.selectedAlert.createdDate).getTime();
      var seconds = Math.floor((timeDifference)/ 1000);
      var minutes = Math.floor(seconds / 60);
      var hours = Math.floor(minutes / 60);
      this.days = Math.floor((hours) / 24);
  
      hours = hours - (this.days * 24);
      minutes = minutes - (this.days * 24 * 60) - (hours * 60);
      seconds = seconds - (this.days * 24 * 60 * 60) - (hours * 60 * 60) - (minutes * 60);
  
      var totalSeconds = seconds < 10 ? "0" + seconds : seconds;
      var totalMinutes = minutes < 10 ? "0" + minutes : minutes;
      var totalHours = hours < 10 ? "0" + hours : hours;
      this.days = this.days < 10? "0" + this.days: this.days;
  
      this.alertTotalTime = totalHours + ":" + totalMinutes + ":" + totalSeconds;

    if(this.selectedAlert.timerStatus != 1){
      this.attendTotal = this.selectedAlert.attendTotal ? this.selectedAlert.attendTotal.split('.') : "";
      this.closeTotal = this.selectedAlert.closeTotal ? this.selectedAlert.closeTotal.split('.') : "";
      this.selectedAlert.attendTotal = this.attendTotal != "" ? this.attendTotal[1] : this.attendTotal;
      this.selectedAlert.closeTotal = this.closeTotal != "" ? this.closeTotal[1] : this.closeTotal;
    }
  }
  
  viewAlert() {
    //Get alert info
    this.alertTimer();
    if(this.selectedAlert.compositionSid){
      this.compositionList = this.selectedAlert.compositionSid.split(',');
    }
    //Initialize map
    mapProperties = {
      mapId: 'mapAlert', 
      mapTypeId: google.maps.MapTypeId.HYBRID,
      mapTypeControl: true,
      rotateControl: false,
      disableDefaultUI: true, 
      zoomControl: true,
      scaleControl: true, 
      streetViewControl: true, 
      fullscreenControl: true,
      tilt: 0
    };
    this.apiService.getOrgZones().subscribe(
      data => {
        if(data!=null){
          initMap(data);
        }
        else{
          mapAlert = new google.maps.Map(this.mapElementAlert.nativeElement, mapProperties);
        }
        this.getAlertInfo();
      }
    );
  }

  getAlertInfo(){
    this.apiService.getHistoryProfile(this.selectedAlert.id).subscribe(
      data => {
          this.profile = data;
          this.c_fields = this.profile.custom;
      },
      error => {
        this.functionsService.errorHandler(error["status"]);
      }
    );

    let messages$ = this.angularFireStore
        .collection<firebase.default.firestore.DocumentData>(`${environment.firebaseConfig.path}/${this.selectedAlert.id}/Messages`).valueChanges();
    
    messages$.pipe(
        map(chat => {
            chat.forEach(c => c.timestamp = c.timestamp * 1000);
            return chat.sort((a, b) => (a.timestamp > b.timestamp) ? 1 : -1);
        })
    ).subscribe(chat => {
        this.chatMessages = chat;
    });
  
    var iconColor = "https://maps.google.com/mapfiles/ms/icons/blue-dot.png";
    var bounds = new google.maps.LatLngBounds();

    if(this.selectedAlert.initialLatitude && this.selectedAlert.initialLongitude){
      mapProperties.center = new google.maps.LatLng(this.selectedAlert["initialLatitude"], this.selectedAlert["initialLongitude"]),
        new google.maps.Marker({
          position: new google.maps.LatLng(this.selectedAlert.initialLatitude, this.selectedAlert.initialLongitude),
          draggable: false,
          map: mapAlert,
          title: "#1",
          icon: {
          url: iconColor
          }
        });
      this.latLngList.push(new google.maps.LatLng(this.selectedAlert.initialLatitude, this.selectedAlert.initialLongitude));
      bounds.extend(new google.maps.LatLng(this.selectedAlert.initialLatitude, this.selectedAlert.initialLongitude));
    }
    
    this.apiService.getAlertPositions(this.selectedAlert.id, this.positionAmount, 1).subscribe(
        data => {
            let jsonString = JSON.stringify(data);
            let jsonObject = JSON.parse(jsonString);
            if(jsonObject[0]!=null){
                for(var i=0;i<jsonObject[0].length;i++){
                    iconColor = ((i+1)==jsonObject[0].length)?"https://maps.google.com/mapfiles/ms/icons/green-dot.png":"https://maps.google.com/mapfiles/ms/icons/blue-dot.png";
                    new google.maps.Marker({
                        position: new google.maps.LatLng(jsonObject[0][i].latitude, jsonObject[0][i].longitude),
                        draggable: false,
                        map: mapAlert,
                        title: "#"+(i+2),
                        icon: {
                            url: iconColor
                        },
                        zIndex: 100
                    });
                    
                    this.recenter_map(jsonObject[0][i].latitude,jsonObject[0][i].longitude);
                    this.latLngList.push(new google.maps.LatLng(jsonObject[0][i].latitude, jsonObject[0][i].longitude));
                    bounds.extend(new google.maps.LatLng(jsonObject[0][i].latitude, jsonObject[0][i].longitude));
                }
                mapAlert.fitBounds(bounds);
                if(jsonObject[0][jsonObject.length - 1]){
                  iconColor = "https://maps.google.com/mapfiles/ms/icons/red-dot.png";
                    new google.maps.Marker({
                        position: new google.maps.LatLng(jsonObject[0][jsonObject.length - 1].latitude, jsonObject[0][jsonObject.length - 1].longitude),
                        draggable: false,
                        map: mapAlert,
                        title: "#"+(jsonObject[0].length + 1),
                        icon: {
                            url: iconColor
                        },
                        zIndex: 100
                    });
                    
                  this.recenter_map(jsonObject[0][jsonObject.length - 1].latitude,jsonObject[0][jsonObject.length - 1].longitude);
                  this.finalLatitude = jsonObject[0][jsonObject.length - 1].latitude;
                  this.finalLongitude = jsonObject[0][jsonObject.length - 1].longitude;
                  this.latLngList.push(new google.maps.LatLng(this.finalLatitude, this.finalLongitude));
                  var linePath = new google.maps.Polyline({
                      path: this.latLngList,
                      geodesic: true,
                      strokeColor: 'black'
                    });
                    
                  linePath.setMap(mapAlert);
                }
              }
              else{
                iconColor = "https://maps.google.com/mapfiles/ms/icons/red-dot.png";
                bounds = new google.maps.LatLngBounds();
  
                if(this.selectedAlert.initialLatitude && this.selectedAlert.initialLongitude){
                  mapProperties.center = new google.maps.LatLng(this.selectedAlert["initialLatitude"], this.selectedAlert["initialLongitude"]),
                    new google.maps.Marker({
                      position: new google.maps.LatLng(this.selectedAlert.initialLatitude, this.selectedAlert.initialLongitude),
                      draggable: false,
                      map: mapAlert,
                      title: "#1",
                      icon: {
                      url: iconColor
                      },
                      zIndex: 100                      
                    });
                  this.latLngList.push(new google.maps.LatLng(this.selectedAlert.initialLatitude, this.selectedAlert.initialLongitude));
                  bounds.extend(new google.maps.LatLng(this.selectedAlert.initialLatitude, this.selectedAlert.initialLongitude));
                }
              }
              if(jsonObject[1]!=null){
                for(var i=0;i<jsonObject[1].length;i++){
                    var agentIconColor = ((i+1)==jsonObject[1].length)?"https://maps.google.com/mapfiles/ms/icons/orange-dot.png":"https://maps.google.com/mapfiles/ms/icons/yellow-dot.png";
                    new google.maps.Marker({
                        position: new google.maps.LatLng(jsonObject[1][i].latitude, jsonObject[1][i].longitude),
                        draggable: false,
                        map: mapAlert,
                        title: "#"+(i+2),
                        icon: {
                            url: agentIconColor
                        },
                    });
                    
                    this.agentLatLngList.push(new google.maps.LatLng(jsonObject[1][i].latitude, jsonObject[1][i].longitude));
                    bounds.extend(new google.maps.LatLng(jsonObject[1][i].latitude, jsonObject[1][i].longitude));
                }
                mapAlert.fitBounds(bounds);
                if(jsonObject[1][jsonObject[1].length - 1]){
                  this.agentFinalLatitude = jsonObject[1][jsonObject.length - 1].latitude;
                  this.agentFinalLongitude = jsonObject[1][jsonObject.length - 1].longitude;
                  this.agentLatLngList.push(new google.maps.LatLng(this.agentFinalLatitude, this.agentFinalLongitude));
                  var agentLinePath = new google.maps.Polyline({
                      path: this.agentLatLngList,
                      geodesic: true,
                      strokeColor: 'black'
                    });
                    
                  agentLinePath.setMap(mapAlert);
                }
            }  
        },
        error => {
            this.functionsService.errorHandler(error["status"]);
        }
    );

    this.apiService.getDocuments(this.selectedAlert.createdBy)
      .subscribe(resp => {
          this.documents = resp;
      }, err => {
          console.error(err);
      });
  }

  recenter_map(latitude, longitude) {
    const position = new google.maps.LatLng(Number.parseFloat(latitude),
        Number.parseFloat(longitude));
    mapAlert.panTo(position);
  }

  previewPDF(doc) {
    if(doc.name.slice(-3) == "pdf"){
        let tab = window.open();
        this.functionsService
        .previewPDF(doc.path)
        .subscribe(data => {
        const fileUrl = URL.createObjectURL(data);
        tab.location.href = fileUrl;
      });
    }
    else{
        this.functionsService.openImage(doc.path);
    }
  }

  previewMedia(url) {
    let tab = window.open();
    tab.location.href = url;
  }
  
  viewActivity(){
    window.open('/activity/'+this.selectedAlert.id, '_blank', 'noopener');
  }

  viewMedia(composition){
    window.open('/media/'+this.selectedAlert.id+'/'+composition, '_blank', 'noopener');
  }
  
  getUserFieldOption() {
    this.apiService.getUserFieldOption().subscribe(
        data => {
          if(data["userFieldOption"] == "YES"){
            this.fieldOption = true;
          }
        },
        error => {
            this.fieldOption = false;
            this.spinner.hide();
        }
    );
  }

    loadAggressors(): void {
        const participantId = this.selectedAlert?.createdBy; 
        // || this.userId;
        console.log("loadAggressors", participantId, this.selectedAlert?.createdBy, this.selectedAlert )
        
        if (participantId) {
            this.apiService.getAggressorsByParticipant(participantId).subscribe({
                next: (data) => {
                    this.aggressors = data;
                    console.log('Aggressors loaded:', this.aggressors);
                },
                error: (error) => {
                    console.error('Error loading aggressors:', error);
                    this.aggressors = [];
                }
            });
        }
    }
    
    openAggressorModal(aggressor: any): void {
        this.selectedAggressor = aggressor;
        this.modalService.open(this.aggressorDetailsModal, {
            centered: true,
            size: 'lg',
            backdrop: 'static'
        });
    }
    
    getStatusText(status: number): string {
        switch (status) {
            case 1: return 'Activo';
            case 2: return 'Por Vencer';
            case 3: return 'Vencido';
            case 4: return 'Cancelado';
            case 5: return 'Pendiente';
            default: return 'Desconocido';
        }
    }
    
    onImageError(event: any): void {
        event.target.src = 'assets/images/default-aggressor.png';
    }


}

function initMap(data){
  geofence = new Geofence(mapProperties);

  // data.forEach(zone => {
  //     geofence.drawStatic(zone["zonePositions"],mapProperties);
  // });
  mapAlert = geofence.map;
}